function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module upload/filerepository
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import PendingActions from '@ckeditor/ckeditor5-core/src/pendingactions';
import CKEditorError, { logWarning } from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
import Collection from '@ckeditor/ckeditor5-utils/src/collection';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import FileReader from './filereader.js';
import uid from '@ckeditor/ckeditor5-utils/src/uid.js';
/**
 * File repository plugin. A central point for managing file upload.
 *
 * To use it, first you need an upload adapter. Upload adapter's job is to handle communication with the server
 * (sending the file and handling server's response). You can use one of the existing plugins introducing upload adapters
 * (e.g. {@link module:easy-image/cloudservicesuploadadapter~CloudServicesUploadAdapter} or
 * {@link module:adapter-ckfinder/uploadadapter~CKFinderUploadAdapter}) or write your own one – see
 * the {@glink framework/guides/deep-dive/upload-adapter "Custom image upload adapter" deep dive guide}.
 *
 * Then, you can use {@link module:upload/filerepository~FileRepository#createLoader `createLoader()`} and the returned
 * {@link module:upload/filerepository~FileLoader} instance to load and upload files.
 *
 * @extends module:core/plugin~Plugin
 */

var FileRepository = /*#__PURE__*/function (_Plugin) {
  _inherits(FileRepository, _Plugin);

  var _super = _createSuper(FileRepository);

  function FileRepository() {
    _classCallCheck(this, FileRepository);

    return _super.apply(this, arguments);
  }

  _createClass(FileRepository, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      /**
       * Collection of loaders associated with this repository.
       *
       * @member {module:utils/collection~Collection} #loaders
       */
      this.loaders = new Collection(); // Keeps upload in a sync with pending actions.

      this.loaders.on('add', function () {
        return _this._updatePendingAction();
      });
      this.loaders.on('remove', function () {
        return _this._updatePendingAction();
      });
      /**
       * Loaders mappings used to retrieve loaders references.
       *
       * @private
       * @member {Map<File|Promise, FileLoader>} #_loadersMap
       */

      this._loadersMap = new Map();
      /**
       * Reference to a pending action registered in a {@link module:core/pendingactions~PendingActions} plugin
       * while upload is in progress. When there is no upload then value is `null`.
       *
       * @private
       * @member {Object} #_pendingAction
       */

      this._pendingAction = null;
      /**
       * A factory function which should be defined before using `FileRepository`.
       *
       * It should return a new instance of {@link module:upload/filerepository~UploadAdapter} that will be used to upload files.
       * {@link module:upload/filerepository~FileLoader} instance associated with the adapter
       * will be passed to that function.
       *
       * For more information and example see {@link module:upload/filerepository~UploadAdapter}.
       *
       * @member {Function} #createUploadAdapter
       */

      /**
       * Number of bytes uploaded.
       *
       * @readonly
       * @observable
       * @member {Number} #uploaded
       */

      this.set('uploaded', 0);
      /**
       * Number of total bytes to upload.
       *
       * It might be different than the file size because of headers and additional data.
       * It contains `null` if value is not available yet, so it's better to use {@link #uploadedPercent} to monitor
       * the progress.
       *
       * @readonly
       * @observable
       * @member {Number|null} #uploadTotal
       */

      this.set('uploadTotal', null);
      /**
       * Upload progress in percents.
       *
       * @readonly
       * @observable
       * @member {Number} #uploadedPercent
       */

      this.bind('uploadedPercent').to(this, 'uploaded', this, 'uploadTotal', function (uploaded, total) {
        return total ? uploaded / total * 100 : 0;
      });
    }
    /**
     * Returns the loader associated with specified file or promise.
     *
     * To get loader by id use `fileRepository.loaders.get( id )`.
     *
     * @param {File|Promise.<File>} fileOrPromise Native file or promise handle.
     * @returns {module:upload/filerepository~FileLoader|null}
     */

  }, {
    key: "getLoader",
    value: function getLoader(fileOrPromise) {
      return this._loadersMap.get(fileOrPromise) || null;
    }
    /**
     * Creates a loader instance for the given file.
     *
     * Requires {@link #createUploadAdapter} factory to be defined.
     *
     * @param {File|Promise.<File>} fileOrPromise Native File object or native Promise object which resolves to a File.
     * @returns {module:upload/filerepository~FileLoader|null}
     */

  }, {
    key: "createLoader",
    value: function createLoader(fileOrPromise) {
      var _this2 = this;

      if (!this.createUploadAdapter) {
        /**
         * You need to enable an upload adapter in order to be able to upload files.
         *
         * This warning shows up when {@link module:upload/filerepository~FileRepository} is being used
         * without {@link #createUploadAdapter defining an upload adapter}.
         *
         * **If you see this warning when using one of the {@glink builds/index CKEditor 5 Builds}**
         * it means that you did not configure any of the upload adapters available by default in those builds.
         *
         * See the {@glink features/images/image-upload/image-upload comprehensive "Image upload overview"} to learn which upload
         * adapters are available in the builds and how to configure them.
         *
         * **If you see this warning when using a custom build** there is a chance that you enabled
         * a feature like {@link module:image/imageupload~ImageUpload},
         * or {@link module:image/imageupload/imageuploadui~ImageUploadUI} but you did not enable any upload adapter.
         * You can choose one of the existing upload adapters listed in the
         * {@glink features/images/image-upload/image-upload "Image upload overview"}.
         *
         * You can also implement your {@glink framework/guides/deep-dive/upload-adapter own image upload adapter}.
         *
         * @error filerepository-no-upload-adapter
         */
        logWarning('filerepository-no-upload-adapter');
        return null;
      }

      var loader = new FileLoader(Promise.resolve(fileOrPromise), this.createUploadAdapter);
      this.loaders.add(loader);

      this._loadersMap.set(fileOrPromise, loader); // Store also file => loader mapping so loader can be retrieved by file instance returned upon Promise resolution.


      if (fileOrPromise instanceof Promise) {
        loader.file.then(function (file) {
          _this2._loadersMap.set(file, loader);
        }) // Every then() must have a catch().
        // File loader state (and rejections) are handled in read() and upload().
        // Also, see the "does not swallow the file promise rejection" test.
        .catch(function () {});
      }

      loader.on('change:uploaded', function () {
        var aggregatedUploaded = 0;

        var _iterator = _createForOfIteratorHelper(_this2.loaders),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _loader = _step.value;
            aggregatedUploaded += _loader.uploaded;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        _this2.uploaded = aggregatedUploaded;
      });
      loader.on('change:uploadTotal', function () {
        var aggregatedTotal = 0;

        var _iterator2 = _createForOfIteratorHelper(_this2.loaders),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _loader2 = _step2.value;

            if (_loader2.uploadTotal) {
              aggregatedTotal += _loader2.uploadTotal;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        _this2.uploadTotal = aggregatedTotal;
      });
      return loader;
    }
    /**
     * Destroys the given loader.
     *
     * @param {File|Promise|module:upload/filerepository~FileLoader} fileOrPromiseOrLoader File or Promise associated
     * with that loader or loader itself.
     */

  }, {
    key: "destroyLoader",
    value: function destroyLoader(fileOrPromiseOrLoader) {
      var _this3 = this;

      var loader = fileOrPromiseOrLoader instanceof FileLoader ? fileOrPromiseOrLoader : this.getLoader(fileOrPromiseOrLoader);

      loader._destroy();

      this.loaders.remove(loader);

      this._loadersMap.forEach(function (value, key) {
        if (value === loader) {
          _this3._loadersMap.delete(key);
        }
      });
    }
    /**
     * Registers or deregisters pending action bound with upload progress.
     *
     * @private
     */

  }, {
    key: "_updatePendingAction",
    value: function _updatePendingAction() {
      var pendingActions = this.editor.plugins.get(PendingActions);

      if (this.loaders.length) {
        if (!this._pendingAction) {
          var t = this.editor.t;

          var getMessage = function getMessage(value) {
            return "".concat(t('Upload in progress'), " ").concat(parseInt(value), "%.");
          };

          this._pendingAction = pendingActions.add(getMessage(this.uploadedPercent));

          this._pendingAction.bind('message').to(this, 'uploadedPercent', getMessage);
        }
      } else {
        pendingActions.remove(this._pendingAction);
        this._pendingAction = null;
      }
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'FileRepository';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [PendingActions];
    }
  }]);

  return FileRepository;
}(Plugin);

export { FileRepository as default };
mix(FileRepository, ObservableMixin);
/**
 * File loader class.
 *
 * It is used to control the process of reading the file and uploading it using the specified upload adapter.
 */

var FileLoader = /*#__PURE__*/function () {
  /**
   * Creates a new instance of `FileLoader`.
   *
   * @param {Promise.<File>} filePromise A promise which resolves to a file instance.
   * @param {Function} uploadAdapterCreator The function which returns {@link module:upload/filerepository~UploadAdapter} instance.
   */
  function FileLoader(filePromise, uploadAdapterCreator) {
    _classCallCheck(this, FileLoader);

    /**
     * Unique id of FileLoader instance.
     *
     * @readonly
     * @member {Number}
     */
    this.id = uid();
    /**
     * Additional wrapper over the initial file promise passed to this loader.
     *
     * @protected
     * @member {module:upload/filerepository~FilePromiseWrapper}
     */

    this._filePromiseWrapper = this._createFilePromiseWrapper(filePromise);
    /**
     * Adapter instance associated with this file loader.
     *
     * @private
     * @member {module:upload/filerepository~UploadAdapter}
     */

    this._adapter = uploadAdapterCreator(this);
    /**
     * FileReader used by FileLoader.
     *
     * @protected
     * @member {module:upload/filereader~FileReader}
     */

    this._reader = new FileReader();
    /**
     * Current status of FileLoader. It can be one of the following:
     *
     * * 'idle',
     * * 'reading',
     * * 'uploading',
     * * 'aborted',
     * * 'error'.
     *
     * When reading status can change in a following way:
     *
     * `idle` -> `reading` -> `idle`
     * `idle` -> `reading -> `aborted`
     * `idle` -> `reading -> `error`
     *
     * When uploading status can change in a following way:
     *
     * `idle` -> `uploading` -> `idle`
     * `idle` -> `uploading` -> `aborted`
     * `idle` -> `uploading` -> `error`
     *
     * @readonly
     * @observable
     * @member {String} #status
     */

    this.set('status', 'idle');
    /**
     * Number of bytes uploaded.
     *
     * @readonly
     * @observable
     * @member {Number} #uploaded
     */

    this.set('uploaded', 0);
    /**
     * Number of total bytes to upload.
     *
     * @readonly
     * @observable
     * @member {Number|null} #uploadTotal
     */

    this.set('uploadTotal', null);
    /**
     * Upload progress in percents.
     *
     * @readonly
     * @observable
     * @member {Number} #uploadedPercent
     */

    this.bind('uploadedPercent').to(this, 'uploaded', this, 'uploadTotal', function (uploaded, total) {
      return total ? uploaded / total * 100 : 0;
    });
    /**
     * Response of the upload.
     *
     * @readonly
     * @observable
     * @member {Object|null} #uploadResponse
     */

    this.set('uploadResponse', null);
  }
  /**
   * A `Promise` which resolves to a `File` instance associated with this file loader.
   *
   * @type {Promise.<File|null>}
   */


  _createClass(FileLoader, [{
    key: "file",
    get: function get() {
      var _this4 = this;

      if (!this._filePromiseWrapper) {
        // Loader was destroyed, return promise which resolves to null.
        return Promise.resolve(null);
      } else {
        // The `this._filePromiseWrapper.promise` is chained and not simply returned to handle a case when:
        //
        //		* The `loader.file.then( ... )` is called by external code (returned promise is pending).
        //		* Then `loader._destroy()` is called (call is synchronous) which destroys the `loader`.
        //		* Promise returned by the first `loader.file.then( ... )` call is resolved.
        //
        // Returning `this._filePromiseWrapper.promise` will still resolve to a `File` instance so there
        // is an additional check needed in the chain to see if `loader` was destroyed in the meantime.
        return this._filePromiseWrapper.promise.then(function (file) {
          return _this4._filePromiseWrapper ? file : null;
        });
      }
    }
    /**
     * Returns the file data. To read its data, you need for first load the file
     * by using the {@link module:upload/filerepository~FileLoader#read `read()`} method.
     *
     * @type {File|undefined}
     */

  }, {
    key: "data",
    get: function get() {
      return this._reader.data;
    }
    /**
     * Reads file using {@link module:upload/filereader~FileReader}.
     *
     * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-read-wrong-status` when status
     * is different than `idle`.
     *
     * Example usage:
     *
     *	fileLoader.read()
     *		.then( data => { ... } )
     *		.catch( err => {
     *			if ( err === 'aborted' ) {
     *				console.log( 'Reading aborted.' );
     *			} else {
     *				console.log( 'Reading error.', err );
     *			}
     *		} );
     *
     * @returns {Promise.<String>} Returns promise that will be resolved with read data. Promise will be rejected if error
     * occurs or if read process is aborted.
     */

  }, {
    key: "read",
    value: function read() {
      var _this5 = this;

      if (this.status != 'idle') {
        /**
         * You cannot call read if the status is different than idle.
         *
         * @error filerepository-read-wrong-status
         */
        throw new CKEditorError('filerepository-read-wrong-status', this);
      }

      this.status = 'reading';
      return this.file.then(function (file) {
        return _this5._reader.read(file);
      }).then(function (data) {
        // Edge case: reader was aborted after file was read - double check for proper status.
        // It can happen when image was deleted during its upload.
        if (_this5.status !== 'reading') {
          throw _this5.status;
        }

        _this5.status = 'idle';
        return data;
      }).catch(function (err) {
        if (err === 'aborted') {
          _this5.status = 'aborted';
          throw 'aborted';
        }

        _this5.status = 'error';
        throw _this5._reader.error ? _this5._reader.error : err;
      });
    }
    /**
     * Reads file using the provided {@link module:upload/filerepository~UploadAdapter}.
     *
     * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `filerepository-upload-wrong-status` when status
     * is different than `idle`.
     * Example usage:
     *
     *	fileLoader.upload()
     *		.then( data => { ... } )
     *		.catch( e => {
     *			if ( e === 'aborted' ) {
     *				console.log( 'Uploading aborted.' );
     *			} else {
     *				console.log( 'Uploading error.', e );
     *			}
     *		} );
     *
     * @returns {Promise.<Object>} Returns promise that will be resolved with response data. Promise will be rejected if error
     * occurs or if read process is aborted.
     */

  }, {
    key: "upload",
    value: function upload() {
      var _this6 = this;

      if (this.status != 'idle') {
        /**
         * You cannot call upload if the status is different than idle.
         *
         * @error filerepository-upload-wrong-status
         */
        throw new CKEditorError('filerepository-upload-wrong-status', this);
      }

      this.status = 'uploading';
      return this.file.then(function () {
        return _this6._adapter.upload();
      }).then(function (data) {
        _this6.uploadResponse = data;
        _this6.status = 'idle';
        return data;
      }).catch(function (err) {
        if (_this6.status === 'aborted') {
          throw 'aborted';
        }

        _this6.status = 'error';
        throw err;
      });
    }
    /**
     * Aborts loading process.
     */

  }, {
    key: "abort",
    value: function abort() {
      var status = this.status;
      this.status = 'aborted';

      if (!this._filePromiseWrapper.isFulfilled) {
        // Edge case: file loader is aborted before read() is called
        // so it might happen that no one handled the rejection of this promise.
        // See https://github.com/ckeditor/ckeditor5-upload/pull/100
        this._filePromiseWrapper.promise.catch(function () {});

        this._filePromiseWrapper.rejecter('aborted');
      } else if (status == 'reading') {
        this._reader.abort();
      } else if (status == 'uploading' && this._adapter.abort) {
        this._adapter.abort();
      }

      this._destroy();
    }
    /**
     * Performs cleanup.
     *
     * @private
     */

  }, {
    key: "_destroy",
    value: function _destroy() {
      this._filePromiseWrapper = undefined;
      this._reader = undefined;
      this._adapter = undefined;
      this.uploadResponse = undefined;
    }
    /**
     * Wraps a given file promise into another promise giving additional
     * control (resolving, rejecting, checking if fulfilled) over it.
     *
     * @private
     * @param filePromise The initial file promise to be wrapped.
     * @returns {module:upload/filerepository~FilePromiseWrapper}
     */

  }, {
    key: "_createFilePromiseWrapper",
    value: function _createFilePromiseWrapper(filePromise) {
      var wrapper = {};
      wrapper.promise = new Promise(function (resolve, reject) {
        wrapper.rejecter = reject;
        wrapper.isFulfilled = false;
        filePromise.then(function (file) {
          wrapper.isFulfilled = true;
          resolve(file);
        }).catch(function (err) {
          wrapper.isFulfilled = true;
          reject(err);
        });
      });
      return wrapper;
    }
  }]);

  return FileLoader;
}();

mix(FileLoader, ObservableMixin);
/**
 * Upload adapter interface used by the {@link module:upload/filerepository~FileRepository file repository}
 * to handle file upload. An upload adapter is a bridge between the editor and server that handles file uploads.
 * It should contain a logic necessary to initiate an upload process and monitor its progress.
 *
 * Learn how to develop your own upload adapter for CKEditor 5 in the
 * {@glink framework/guides/deep-dive/upload-adapter "Custom upload adapter" guide}.
 *
 * @interface UploadAdapter
 */

/**
 * Executes the upload process.
 * This method should return a promise that will resolve when data will be uploaded to server. Promise should be
 * resolved with an object containing information about uploaded file:
 *
 *		{
 *			default: 'http://server/default-size.image.png'
 *		}
 *
 * Additionally, other image sizes can be provided:
 *
 *		{
 *			default: 'http://server/default-size.image.png',
 *			'160': 'http://server/size-160.image.png',
 *			'500': 'http://server/size-500.image.png',
 *			'1000': 'http://server/size-1000.image.png',
 *			'1052': 'http://server/default-size.image.png'
 *		}
 *
 * You can also pass additional properties from the server. In this case you need to wrap URLs
 * in the `urls` object and pass additional properties along the `urls` property.
 *
 * 		{
 * 			myCustomProperty: 'foo',
 * 			urls: {
 *				default: 'http://server/default-size.image.png',
 *				'160': 'http://server/size-160.image.png',
 *				'500': 'http://server/size-500.image.png',
 *				'1000': 'http://server/size-1000.image.png',
 *				'1052': 'http://server/default-size.image.png'
 *			}
 *		}
 *
 * NOTE: When returning multiple images, the widest returned one should equal the default one. It is essential to
 * correctly set `width` attribute of the image. See this discussion:
 * https://github.com/ckeditor/ckeditor5-easy-image/issues/4 for more information.
 *
 * Take a look at {@link module:upload/filerepository~UploadAdapter example Adapter implementation} and
 * {@link module:upload/filerepository~FileRepository#createUploadAdapter createUploadAdapter method}.
 *
 * @method module:upload/filerepository~UploadAdapter#upload
 * @returns {Promise.<Object>} Promise that should be resolved when data is uploaded.
 */

/**
 * Aborts the upload process.
 * After aborting it should reject promise returned from {@link #upload upload()}.
 *
 * Take a look at {@link module:upload/filerepository~UploadAdapter example Adapter implementation} and
 * {@link module:upload/filerepository~FileRepository#createUploadAdapter createUploadAdapter method}.
 *
 * @method module:upload/filerepository~UploadAdapter#abort
 */

/**
 * Object returned by {@link module:upload/filerepository~FileLoader#_createFilePromiseWrapper} method
 * to add more control over the initial file promise passed to {@link module:upload/filerepository~FileLoader}.
 *
 * @protected
 * @typedef {Object} module:upload/filerepository~FilePromiseWrapper
 * @property {Promise.<File>} promise Wrapper promise which can be chained for further processing.
 * @property {Function} rejecter Rejects the promise when called.
 * @property {Boolean} isFulfilled Whether original promise is already fulfilled.
 */